module.exports = __webpack_public_path__ + "static/media/Bok.b2529c76.PNG";